/* hd-mini-fan.js —— 悬浮迷你相册（目录页 product-catalog + 详情页 main-product 共用）
 * 统一：横滑手势 / touch-action / 散卡落位固定 / CSS 兜底 / 点击放大 / 计数。
 * 用法：HDMiniFan.init({ prefix, getList, getPos, onGo, onOpen, fanEl })
 *   prefix  : 'pc' | 'pm'（DOM id 前缀）
 *   getList : () => [{src,zoom,alpha}, ...] 对象数组
 *   getPos  : () => 当前 index（在 getList() 数组内）
 *   onGo    : (dir) => 切图（dir=1 下一张 / -1 上一张）
 *   onOpen  : (it)  => 点主图放大回调
 *   fanEl   : 主相册 DOM 元素（用于「滚出视口才浮现」判断）
 * 主相册每次渲染完调用 HDMiniFan.sync() 同步迷你相册。
 */
(function () {
  'use strict';

  var _o = null, _el = null, _stack = null;
  var _cards = null, _grp = null, _seq = 0, _swipeAt = 0;

  var MINI_POOL = [
    ['translate(-6px,4px) rotate(-5deg) scale(.985)','translate(7px,5px) rotate(5deg) scale(.98)','translate(-5px,7px) rotate(-4.5deg) scale(.975)'],
    ['translate(6px,5px) rotate(4.5deg) scale(.985)','translate(-7px,4px) rotate(-5deg) scale(.98)','translate(7px,7px) rotate(5.5deg) scale(.975)'],
    ['translate(-5px,6px) rotate(4.5deg) scale(.985)','translate(7px,6px) rotate(-5deg) scale(.98)','translate(-6px,8px) rotate(5.5deg) scale(.975)']
  ];

  function injectCSS() {
    if (document.getElementById('hd-mini-fan-css')) return;
    var st = document.createElement('style');
    st.id = 'hd-mini-fan-css';
    st.textContent = [
      '.hd-mini-fan{ touch-action:pan-y; }',
      '.hd-mini-fan__img{ touch-action:pan-y; border:0; background:none; }',
      '.hd-mini-fan__card--stack{ transition:none; }',
      '.hd-mini-fan__card--stack.hd-mini-fan__stack-1{ z-index:7; transform:translate(-6px,4px) rotate(-5deg) scale(.985); }',
      '.hd-mini-fan__card--stack.hd-mini-fan__stack-2{ z-index:6; transform:translate(7px,5px) rotate(5deg) scale(.98); }',
      '.hd-mini-fan__card--stack.hd-mini-fan__stack-3{ z-index:5; transform:translate(-5px,7px) rotate(-4.5deg) scale(.975); }'
    ].join('');
    document.head.appendChild(st);
  }

  function sync() {
    if (!_o || !_el || !_stack) return;
    var list = _o.getList();
    if (!list || !list.length) return;
    var pos = _o.getPos();
    if (pos < 0 || pos >= list.length) pos = 0;
    if (!_grp) _grp = MINI_POOL[Math.floor(Math.random() * MINI_POOL.length)];
    var grp = _grp;
    var srcs = [list[pos].src || ''];
    var tfs = [''];
    for (var s = 1; s <= 3; s++) {
      var j = (pos + s) % list.length;
      if (j === pos) break;
      srcs.push(list[j].src || '');
      tfs.push(grp[s - 1]);
    }
    if (!_cards || _cards.length !== srcs.length) {
      _stack.textContent = '';
      _cards = [];
      for (var k = 0; k < srcs.length; k++) {
        var d = document.createElement('div');
        d.className = 'hd-mini-fan__card ' + (k === 0 ? 'hd-mini-fan__card--main' : 'hd-mini-fan__card--stack hd-mini-fan__stack-' + k);
        if (tfs[k]) d.style.transform = tfs[k];
        var im = document.createElement('img');
        im.alt = '';
        im.src = srcs[k];
        if (k > 0) im.loading = 'lazy';
        d.appendChild(im);
        _stack.appendChild(d);
        _cards.push(d);
      }
    } else {
      for (var k2 = 0; k2 < _cards.length; k2++) {
        var img2 = _cards[k2].firstChild;
        if (img2 && img2.getAttribute('src') !== srcs[k2]) img2.setAttribute('src', srcs[k2]);
        if (tfs[k2]) _cards[k2].style.transform = tfs[k2];
      }
    }
    var mySeq = ++_seq;
    requestAnimationFrame(function () {
      if (mySeq !== _seq) return;
      for (var k3 = 1; k3 < _cards.length; k3++) {
        if (tfs[k3]) _cards[k3].style.transform = tfs[k3];
      }
    });
  }

  function init(o) {
    injectCSS();
    /* 防重复 init：目录页 init() 会「缓存先渲染 + 网络刷新」走两次 showDetail→init，
       重复 init 会把 touch/click 事件绑两次 ⇒ 每滑一次切两张。同一 prefix 只绑一次，后续靠 sync 更新。 */
    if (_o && _o.prefix === (o && o.prefix)) return;
    _o = o || {};
    _el = document.getElementById(_o.prefix + 'MiniFan');
    _stack = document.getElementById(_o.prefix + 'MiniStack');
    if (!_el) return;
    var prev = document.getElementById(_o.prefix + 'MiniPrev');
    var next = document.getElementById(_o.prefix + 'MiniNext');
    var btn = document.getElementById(_o.prefix + 'MiniBtn');

    _swipeAt = 0;
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); if (Date.now() - _swipeAt < 400) return; _o.onGo(-1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); if (Date.now() - _swipeAt < 400) return; _o.onGo(1); });
    if (btn) btn.addEventListener('click', function () {
      if (Date.now() - _swipeAt < 400) return;
      var list = _o.getList(), pos = _o.getPos();
      var it = list && list[pos];
      if (it && _o.onOpen) _o.onOpen(it);
    });

    var mx = 0, my = 0, mlock = 0;
    _el.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { mlock = 2; return; }
      var t = e.touches[0]; mx = t.clientX; my = t.clientY; mlock = 0;
    }, { passive: true });
    _el.addEventListener('touchmove', function (e) {
      if (mlock === 2) return;
      var t = e.touches[0]; if (!t) return;
      var mvx = Math.abs(t.clientX - mx), mvy = Math.abs(t.clientY - my);
      if (mlock === 0 && (mvx > 8 || mvy > 8)) mlock = (mvx > mvy * 1.2) ? 1 : 2;
    }, { passive: true });
    _el.addEventListener('touchend', function (e) {
      var wasH = (mlock === 1);
      mlock = 0;
      if (!wasH) return;
      _swipeAt = Date.now();
      var t = e.changedTouches[0]; if (!t) return;
      var dx = t.clientX - mx, dy = t.clientY - my;
      if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.1) {
        _o.onGo(dx < 0 ? 1 : -1);
      }
    }, { passive: true });
    _el.addEventListener('touchcancel', function () { mlock = 0; }, { passive: true });

    function onScroll() {
      if (window.innerWidth > 768) { _el.classList.remove('is-on'); return; }
      var r = _o.fanEl ? _o.fanEl.getBoundingClientRect() : null;
      var list = _o.getList();
      _el.classList.toggle('is-on', !!r && r.bottom < 56 && list.length > 1);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    sync();
    onScroll();
  }

  window.HDMiniFan = { init: init, sync: sync };
})();
